// Canonical offering form shape: allowed enum values, the form value type,
// and the empty template. Moved here from client/src/pages/offer-form.tsx
// (which re-exports everything) so the server-side Build-with-AI persist
// path can normalize builder output with the exact same source of truth the
// form uses. Pure data — no React, no UI imports.

export const OFFER_TYPES = [
  "service","subscription","software","course","event","membership","consultation",
  "audit","package","agency_service","digital_product","marketplace","insurance","hybrid","other",
];
export const PAIN_INTENSITIES = ["low","medium","high","urgent"];
export const TIME_TO_VALUE = ["immediate","days","weeks","months","ongoing"];
export const PRICING_MODELS = [
  "fixed","hourly","retainer","project_based","subscription","performance_based",
  "custom_quote","free_consultation","usage_based","other",
];
export const DELIVERY_MODELS = [
  "done_for_you","done_with_you","self_serve","advisory","managed_service","in_person","remote","hybrid",
];
export const DELIVERY_LOCATIONS = ["online","local","national","global","specific_regions"];
export const PRIMARY_CTAS = [
  "book_call","get_quote","start_trial","buy_now","request_demo","apply",
  "schedule_consultation","sign_up","download","contact_us",
];
export const SERVICE_TYPES = [
  "consulting","agency","professional_service","local_service","coaching","implementation",
  "creative_service","financial_service","home_service","healthcare_service","legal_service","other",
];
export const SERVICE_FORMATS = [
  "one_time","recurring","ongoing","project","audit","consultation","package","retainer",
];

export interface OfferFormValue {
  name: string;
  slug?: string;
  status?: string;
  offerType: string;
  offerCategory?: string | null;
  summary?: string | null;
  shortDescription?: string | null;
  buyerProblem?: any;
  desiredOutcome?: any;
  valueProposition?: any;
  offerDetails?: any;
  fulfillment?: any;
  proof?: any;
  riskReversal?: any;
  objections?: any;
  conversion?: any;
  personaFit?: any;
  creativeInputs?: any;
  serviceDetails?: any;
}

export const emptyOffer = (): OfferFormValue => ({
  name: "",
  offerType: "service",
  offerCategory: "",
  summary: "",
  shortDescription: "",
  buyerProblem: { primary_problem: "", secondary_problems: [], pain_intensity: "medium", current_alternatives: [], status_quo_cost: "" },
  desiredOutcome: { primary_outcome: "", secondary_outcomes: [], emotional_outcome: "", business_or_life_impact: "", time_to_value: "weeks" },
  valueProposition: { one_liner: "", core_benefits: [], differentiators: [], why_now: "", why_this_brand: "" },
  offerDetails: { what_is_included: [], what_is_not_included: [], packages_or_tiers: [], pricing_model: "custom_quote", availability: "" },
  fulfillment: { delivery_model: "done_with_you", delivery_location: "online", process_steps: [], timeline: "", customer_requirements: [], onboarding_steps: [] },
  proof: { case_studies: [], testimonials: [], credentials: [], metrics: [], before_after_examples: [], trust_signals: [] },
  riskReversal: { guarantee: "", refund_policy: "", contract_terms: "", trial_or_intro_offer: "" },
  objections: [],
  conversion: { primary_cta: "book_call", cta_copy: "", conversion_url: "", lead_capture_fields: [], qualification_criteria: [] },
  personaFit: [],
  creativeInputs: { hooks: [], angles: [], claims: [], forbidden_claims: [], tone: "", visual_direction: [], ugc_scenarios: [], landing_page_messages: [] },
  serviceDetails: { service_type: "consulting", service_format: "consultation", service_scope: "", deliverables: [], client_inputs_needed: [], provider_actions: [], client_actions: [], success_definition: "", service_area: "", capacity_limits: "", booking_or_sales_process: [] },
});
